module.exports = __webpack_public_path__ + "static/media/parks.4e53a9d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityBadge/icons/parks.svg
// module id = 296
// module chunks = 0